import React from 'react'
import Helmet from 'react-helmet'

function SEO({ description, lang, title, author }) {

  const _lang = lang ? lang : 'pt_BR'
  const _description = description ? description : 'Calcular macrosnutrientes: proteínas, carboidratos e gorduras; para planejamento alimentar'
  const _title = title ? title : 'Calcular Macrosnutrientes para Planejamento Alimentar | INFO Nutrientes'
  const _author = author ? author : 'INFO Nutrientes'

  return (
    <Helmet
      htmlAttributes={{
        _lang,
      }}
      title={_title}
      titleTemplate={_title}
      meta={[
        {
          name: `viewport`,
          content: `minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no`,
        },
        {
          name: `description`,
          content: _description,
        },
        {
          property: `og:title`,
          content: _title,
        },
        {
          property: `og:description`,
          content: _description,
        },
        {
          property: `og:locale`,
          content: `pt_BR`
        },
        {
          property: `og:image`,
          content: `https://infonutrientes.com.br/calcular-taxa-metabolica-basal/info-logo-fb-tmb.jpg`
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: _author,
        },
        {
          name: `twitter:title`,
          content: _title,
        },
        {
          name: `twitter:description`,
          content: _description,
        },
      ]}
    />
  )
}

export default SEO
